<template>
  <div class="faq-page">
    <!-- Start cyber Main Menu Area -->
    <div
      id="sticky-header"
      class="cyber_nav_manu d-md-none d-lg-block d-sm-none d-none"
    >
      <div class="container">
        <div class="row align-items-center">
          <div class="navbar-content">
            <div class="logo">
              <a class="logo_img" href="/" title="ipipbright">
                <img :src="require('../assets/images/ipipbright.png')" style="height: 73px;" alt="" />
              </a>
            </div>
            <nav class="cyber_menu">
              <ul class="nav_scroll">
                <li><router-link to="/" class="nav-link">{{ t.home }}</router-link></li>
                <li>
                  <router-link to="/" class="nav-link active">{{ t.services }}</router-link>
                  <ul class="sub-menu">
                    <li><router-link to="/dynamic">{{ t.serviceDynamic }}</router-link></li>
                  </ul>
                </li>
                <li><router-link to="/faq" class="nav-link">{{ t.blog }}</router-link>
                  <ul class="sub-menu">
                    <li><router-link to="/faq">{{ t.faq }}</router-link></li>
                  </ul>
                </li>
                <li>
                  <a href="javascript:void(0);" >{{ languageState.currentLanguage === 'en' ? 'English' : '简体中文' }}</a>
                  <ul class="sub-menu">
                    <li><a href="javascript:void(0);" @click="setLanguage('en')">English</a></li>
                    <li><a href="javascript:void(0);" @click="setLanguage('zh')">简体中文</a></li>
                  </ul>
                </li>
              </ul>
              <div class="auth-buttons">
                <router-link to="/login" class="auth-btn login-btn">{{ t.signIn }}</router-link>
                <router-link to="/register" class="auth-btn register-btn">{{ t.signUp }}</router-link>
              </div>
            </nav>
          </div>
        </div>
      </div>
    </div>
    <div class="mobile-menu-area d-sm-block d-md-block d-lg-none">
      <div class="mobile-menu-container">
        <div class="mobile-menu-header">
          <div class="mobile-menu-logo">
            <a href="/" title="ipipbright">
              <img :src="require('../assets/images/ipipbright.png')" style="height: 40px; margin: 10px 0 0 15px;" alt="ipipbright" />
            </a>
          </div>
          <a href="javascript:void(0);" class="mobile-menu-toggle" @click="toggleMobileMenu">
            <span></span>
            <span></span>
            <span></span>
          </a>
        </div>
        <div class="mobile-menu-body" v-show="isMobileMenuOpen">
          <ul class="mobile-menu-list">
            <li class="mobile-menu-item"><a href="javascript:void(0);" class="mobile-menu-link" @click="handleMobileNavClick('/')">{{ t.home }}</a></li>
            <li class="mobile-menu-item">
              <div class="mobile-menu-link-wrapper">
                <a href="#home" class="mobile-menu-link has-submenu" @click.stop="toggleDropdown($event, 'Package')">{{ t.services }}</a>
                <a href="javascript:void(0);" class="mobile-menu-expand" @click.stop="toggleDropdown($event, 'Package')">+</a>
              </div>
              <ul class="mobile-sub-menu" v-show="activeDropdown === 'Package'">
                <li class="mobile-sub-menu-item"><a href="javascript:void(0);" class="mobile-sub-menu-link" @click="handleMobileNavClick('/dynamic')">{{ t.serviceDynamic }}</a></li>
              </ul>
            </li>
            <li class="mobile-menu-item">
              <div class="mobile-menu-link-wrapper">
                <a href="/faq" class="mobile-menu-link has-submenu" @click.stop="toggleDropdown($event, 'Tutorial')">{{ t.faq }}</a>
                <a href="javascript:void(0);" class="mobile-menu-expand" @click.stop="toggleDropdown($event, 'Tutorial')">+</a>
              </div>
              <ul class="mobile-sub-menu" v-show="activeDropdown === 'Tutorial'">
                <li class="mobile-sub-menu-item"><a href="javascript:void(0);" class="mobile-sub-menu-link" @click="handleMobileNavClick('/faq')">{{ t.faq }}</a></li>
              </ul>
            </li>
            <li class="mobile-menu-item">
              <div class="mobile-menu-link-wrapper">
                <a href="#language" class="mobile-menu-link has-submenu" @click.stop="toggleDropdown($event, 'English')" >{{ languageState.currentLanguage === 'en' ? 'English' : '简体中文' }}</a>
                <a href="javascript:void(0);" class="mobile-menu-expand" @click.stop="toggleDropdown($event, 'English')">+</a>
              </div>
              <ul class="mobile-sub-menu" v-show="activeDropdown === 'English'">
                <li class="mobile-sub-menu-item"><a href="javascript:void(0);" class="mobile-sub-menu-link" @click="setLanguage('en')">English</a></li>
                <li class="mobile-sub-menu-item"><a href="javascript:void(0);" class="mobile-sub-menu-link" @click="setLanguage('zh')">简体中文</a></li>
              </ul>
            </li>
          </ul>
          <div class="mobile-auth-buttons">
            <a href="javascript:void(0);" class="mobile-auth-btn mobile-login-btn" @click="handleMobileNavClick('/login')">{{ t.signIn }}</a>
            <a href="javascript:void(0);" class="mobile-auth-btn mobile-register-btn" @click="handleMobileNavClick('/register')">{{ t.signUp }}</a>
          </div>
        </div>
      </div>
    </div>
    <!-- End cyber Main Menu Area -->

    <!-- Banner Section -->
    <section class="faq-banner-section ptb-100">
      <div class="container">
        <div class="banner-content text-center">
          <h1>{{ t.faqTitle }}</h1>
          <p>{{ t.faqSubtitle }}</p>
        </div>
      </div>
    </section>
    <!-- End Banner Section -->

    <!-- FAQ Section -->
    <section class="faq-section ptb-100 bg-light">
      <div class="container">
        <div class="faq-content">
          <div class="faq-tabs">
            <div class="tabs-container">
              <div class="tab-buttons">
                <button 
                  v-for="tab in tabs" 
                  :key="tab.value"
                  :class="{ 'active': activeTab === tab.value }"
                  @click="activeTab = tab.value"
                  class="tab-btn"
                >
                  {{ tab.label }}
                </button>
              </div>
              
              <div class="tab-content">
                <!-- 入门 Tab -->
                <div v-if="activeTab === 'first'" class="tab-panel">
                  <div class="faq-accordion">
                    <div 
                      v-for="(item, index) in faqData.first" 
                      :key="index"
                      class="accordion-item"
                      :class="{ 'active': activeAccordion.first === index }"
                      @click="toggleAccordion('first', index)"
                    >
                      <div class="accordion-header">
                        <h3>{{ item.question }}</h3>
                        <span class="accordion-icon">{{ activeAccordion.first === index ? '−' : '+' }}</span>
                      </div>
                      <div class="accordion-body" v-if="activeAccordion.first === index">
                        <p v-html="item.answer"></p>
                      </div>
                    </div>
                  </div>
                </div>
                
                <!-- 价格 Tab -->
                <div v-if="activeTab === 'second'" class="tab-panel">
                  <div class="faq-accordion">
                    <div 
                      v-for="(item, index) in faqData.second" 
                      :key="index"
                      class="accordion-item"
                      :class="{ 'active': activeAccordion.second === index }"
                      @click="toggleAccordion('second', index)"
                    >
                      <div class="accordion-header">
                        <h3>{{ item.question }}</h3>
                        <span class="accordion-icon">{{ activeAccordion.second === index ? '−' : '+' }}</span>
                      </div>
                      <div class="accordion-body" v-if="activeAccordion.second === index">
                        <p v-html="item.answer"></p>
                      </div>
                    </div>
                  </div>
                </div>
                
                <!-- 账户 Tab -->
                <div v-if="activeTab === 'third'" class="tab-panel">
                  <div class="faq-accordion">
                    <div 
                      v-for="(item, index) in faqData.third" 
                      :key="index"
                      class="accordion-item"
                      :class="{ 'active': activeAccordion.third === index }"
                      @click="toggleAccordion('third', index)"
                    >
                      <div class="accordion-header">
                        <h3>{{ item.question }}</h3>
                        <span class="accordion-icon">{{ activeAccordion.third === index ? '−' : '+' }}</span>
                      </div>
                      <div class="accordion-body" v-if="activeAccordion.third === index">
                        <p v-html="item.answer"></p>
                      </div>
                    </div>
                  </div>
                </div>
                
                <!-- 故障 Tab -->
                <div v-if="activeTab === 'fourth'" class="tab-panel">
                  <div class="faq-accordion">
                    <div 
                      v-for="(item, index) in faqData.fourth" 
                      :key="index"
                      class="accordion-item"
                      :class="{ 'active': activeAccordion.fourth === index }"
                      @click="toggleAccordion('fourth', index)"
                    >
                      <div class="accordion-header">
                        <h3>{{ item.question }}</h3>
                        <span class="accordion-icon">{{ activeAccordion.fourth === index ? '−' : '+' }}</span>
                      </div>
                      <div class="accordion-body" v-if="activeAccordion.fourth === index">
                        <p v-html="item.answer"></p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- End FAQ Section -->

    <!-- Footer Area -->
    <div class="footer-middle" id="footer">
      <div class="container">
        <div class="row">
          <!--footer widget 1 -->
          <div class="col-md-6 col-lg-3 col-xs-12">
            <div class="widget widgets_company_info">
              <h2 class="widget-title">IPIPBright</h2>
              <div class="company_info_desc">
                <p>
                  {{ t.footerDesc }}
                </p>
              </div>
              <div class="social_media">
                <h3>{{ t.followUs }}</h3>
                <a href="javascript:void(0);"><i class="fa-brands fa-facebook-f"></i></a>
                <a href="javascript:void(0);"><i class="fa-brands fa-linkedin-in"></i></a>
                <a href="javascript:void(0);"><i class="fa-brands fa-telegram"></i></a>
              </div>
            </div>
          </div>

          <!--footer widget 2 -->
          <div class="col-md-6 col-lg-3 col-xs-12">
            <div id="em_recent_post_widget-8" class="widget widget_recent_data">
              <div class="single-widget-item">
                <h2 class="widget-title">{{ t.quickLinks }}</h2>
                <div class="quick-link-item">
                  <div class="quick-post-text">
                    <h4>
                      <i class="fa fa-angle-right"></i
                      ><a href="/"> {{ t.home }} </a>
                    </h4>
                  </div>
                </div>
                <div class="quick-link-item">
                  <div class="quick-post-text">
                    <h4>
                      <i class="fa fa-angle-right"></i
                      ><a href="/privacy"> {{ t.privacyPolicy }} </a>
                    </h4>
                  </div>
                </div>
                <div class="quick-link-item">
                  <div class="quick-post-text">
                    <h4>
                      <i class="fa fa-angle-right"></i
                      ><a href="/service-policy"> {{ t.servicePolicy }} </a>
                    </h4>
                  </div>
                </div>
                <div class="quick-link-item">
                  <div class="quick-post-text">
                    <h4>
                      <i class="fa fa-angle-right"></i
                      ><a href="/faq"> {{ t.faq }} </a>
                    </h4>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!--footer widget 3 -->
          <div class="col-md-6 col-lg-3 col-xs-12">
            <div id="em_recent_post_widget-7" class="widget widget_recent_data">
              <div class="single-widget-item">
                <h2 class="widget-title">{{ t.productServices }}</h2>
                <div class="quick-link-item">
                  <div class="quick-post-text">
                    <h4>
                      <i class="fa fa-angle-right"></i
                      ><a href="/dynamic"> {{ t.serviceDynamic }} </a>
                    </h4>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!--footer widget 4 -->
          <div class="col-lg-3 col-md-6 col-xs-12 last">
            <div class="widget widget_get_quote">
              <h2 class="widget-title">{{ t.contactUs }}</h2>
              <div class="widget_get_quote_content">
                <div class="widget_quote_text">
                  <div class="footer_quote_text_decripsition">
                    <div class="footer_quote_decripsition_inner">
                      <p>
                        {{ t.supportText }}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- End Footer Area -->
    
    <!-- Footer Bottom Area -->
    <div class="footer-bottom">
      <div class="container">
        <div class="row">
          <div class="col-md-12">
            <div class="footer-bottom-content">
              <p>{{ t.copyright }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- End Footer Bottom Area -->

    <!-- Simple go to top button -->
    <div 
      id="simple-go-top" 
      @click="scrollToTop"
      style="
        position: fixed;
        bottom: 30px;
        right: 30px;
        width: 55px;
        height: 55px;
        background: linear-gradient(135deg, #1581c6, #1581c6);
        color: white;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        z-index: 9999999;
        font-size: 26px;
        font-weight: bold;
        box-shadow: 0 8px 25px rgba(21, 129, 198, 0.6);
        transition: all 0.3s ease;
        opacity: 0;
        visibility: hidden;
        border: none;
      "
    >
      ↑
    </div>
  </div>
</template>

<script>
export default {
  name: 'FAQPage',
  inject: ['changeLanguage', 'languageState'],
  data() {
    return {
      isSticky: false,
      isNavCollapsed: true,
      isMobileMenuOpen: false,
      activeDropdown: '',
      activeTab: 'first',
      activeAccordion: {
        first: null,
        second: null,
        third: null,
        fourth: null
      }
    };
  },
  computed: {
    t() {
      const lang = this.languageState.currentLanguage;
      return {
        home: lang === 'zh' ? '首页' : 'Home',
        services: lang === 'zh' ? '套餐' : 'Package',
        serviceDynamic: lang === 'zh' ? '动态住宅' : 'Dynamic residence',
        serviceStatic: lang === 'zh' ? '静态住宅' : 'Static residence',
        blog: lang === 'zh' ? '教程中心' : 'Tutorial',
        faq: lang === 'zh' ? '常见问题' : 'FAQs',
        signIn: lang === 'zh' ? '登录' : 'Sign In',
        signUp: lang === 'zh' ? '注册' : 'Sign Up',
        faqTitle: lang === 'zh' ? '常见问题解答' : 'Frequently Asked Questions',
        faqSubtitle: lang === 'zh' ? '了解更多关于我们代理服务的信息' : 'Learn more about our proxy services',
        // Tabs
        tabGettingStarted: lang === 'zh' ? '入门' : 'Getting Started',
        tabPricing: lang === 'zh' ? '价格' : 'Pricing',
        tabAccount: lang === 'zh' ? '账户' : 'Account',
        tabTroubleshooting: lang === 'zh' ? '故障' : 'Troubleshooting',
        // FAQ Data - Getting Started
        faq1q: lang === 'zh' ? '使用IP代理为什么没有网络？' : 'Why is there no network when using IP proxy?',
        faq1a: lang === 'zh' ? '海外IP需要在境外环境上使用，如已经在境外环境，请检查服务器的IP地址是否添加到白名单' : 'Overseas IP needs to be used in an overseas environment. If you are already in an overseas environment, please check if the server IP address has been added to the whitelist.',
        faq2q: lang === 'zh' ? '什么是IP白名单？' : 'What is an IP whitelist?',
        faq2a: lang === 'zh' ? 'IP白名单是ipipbright代理的验证机制，在使用代理服务时，需要先将使用代理的服务器IP添加到白名单，有以下两种形式：<br>（1）本机服务器使用代理：生成链接后，系统将提示添加本机服务器IP至白名单，确认添加后即可使用代理服务<br>（2）其他服务器使用代理：在ipipbright账户后台添加IP白名单，支持添加多个IP白名单' : 'IP whitelist is the verification mechanism of ipipbright proxy. When using proxy services, you need to add the server IP using the proxy to the whitelist first. There are two forms:<br>(1) Local server uses proxy: After generating a link, the system will prompt you to add the local server IP to the whitelist. After confirming the addition, you can use the proxy service.<br>(2) Other servers use proxy: Add IP whitelist in the ipipbright account backend, supporting multiple IP whitelist additions.',
        faq3q: lang === 'zh' ? 'IP支持哪些协议？' : 'Which protocols does IP support?',
        faq3a: lang === 'zh' ? '支持HTTP、HTTPS、SOCKS5三种协议<br>官网获取的是HTTP、HTTPS，协议互通，在代理时设置请求协议直接代理即可；如果有获取不到的情况，可以联系客服进行协助处理' : 'Supports HTTP, HTTPS, and SOCKS5 protocols.<br>The official website provides HTTP and HTTPS, which are interoperable. When proxying, you can directly set the request protocol for proxying. If you cannot obtain it, you can contact customer service for assistance.',
        faq4q: lang === 'zh' ? 'IP使用有哪些限制？' : 'What are the limitations of IP usage?',
        faq4a: lang === 'zh' ? 'IP没有请求和并发限制，api链接提取频率是1秒1次，IP提取单次最多可达900个。有其他额外需求联系客服协助处理' : 'There are no request or concurrency limits for IP. The API link extraction frequency is 1 time per second, and the maximum number of IPs extracted at a time can reach 900. For other additional needs, contact customer service for assistance.',
        faq5q: lang === 'zh' ? '手机可以设置代理吗？' : 'Can mobile phones set up proxies?',
        faq5a: lang === 'zh' ? '手机同样需要境外环境，打开手机的WLAN设置，选择连接的无线网络；点击无线网络设置，代理设置点击手动；手动输入在ipipbright获取的IP和端口' : 'Mobile phones also need an overseas environment. Open the phone\'s WLAN settings, select the connected wireless network; click wireless network settings, click manual for proxy settings; manually enter the IP and port obtained from ipipbright.',
        faq6q: lang === 'zh' ? '获取的代理IP实际不是最终的出口IP' : 'The obtained proxy IP is not the final exit IP?',
        faq6a: lang === 'zh' ? 'IP为隧道转发，出口是真实IP，IP段一致，端口不同，每一个端口对应一个ip' : 'IP is tunnel forwarding, the exit is a real IP, the IP segment is consistent, ports are different, each port corresponds to an IP.',
        faq7q: lang === 'zh' ? '如何检查本地网络？' : 'How to check the local network?',
        faq7a: lang === 'zh' ? '您可以打开cmd输入curl ipinfo.io查看当前的IP地址' : 'You can open cmd and enter curl ipinfo.io to check the current IP address.',
        faq8q: lang === 'zh' ? 'ipipbright推广计划能永久奖励吗？' : 'Can ipipbright promotion plan give permanent rewards?',
        faq8a: lang === 'zh' ? '区别于其他的推广计划，ipipbright不会限制您的奖励周期，永久收益！<br>（1）推荐新用户免费试用ipipbright， 获3元/位现金奖励！<br>（2）推荐新用户购买获30%奖励，高至5000元！<br>（3）若用户复购，您可享受每笔订单5%奖励，每笔最高1000元， 立刻赚取奖励！' : 'Unlike other promotion plans, ipipbright does not limit your reward period, permanent income!<br>(1) Recommend new users to try ipipbright for free, get 3 yuan/cash reward!<br>(2) Recommend new users to purchase and get 30% reward, up to 5000 yuan!<br>(3) If users repurchase, you can enjoy 5% reward for each order, up to 1000 yuan per order, earn rewards immediately!',
        faq9q: lang === 'zh' ? 'ipipbright代理覆盖哪些国家地区？' : 'Which countries and regions does ipipbright proxy cover?',
        faq9a: lang === 'zh' ? '目前覆盖了包括美国、英国、加拿大、印度、韩国等热门国家在内的220多个国家和地区，<br>为用户提供超9000万IP数量，点击 此处了解更多国家及IP数量。' : 'Currently covering more than 220 countries and regions including popular countries such as the United States, the United Kingdom, Canada, India, South Korea, etc.,<br>providing users with more than 90 million IPs, click here to learn more about countries and IP quantities.',
        faq10q: lang === 'zh' ? 'ipipbright提供哪些代理方案？' : 'What proxy solutions does ipipbright provide?',
        faq10a: lang === 'zh' ? 'ipipbright目前为您提供以下6种解决方案：<br>动态住宅、 静态住宅、 独享数据中心、 动态长效ISP、 动态数据中心、 移动代理。<br>另外，我们还提供“ 网页解锁工具”，实现网页爬虫率大于99.99%，一键发送请求，即可轻松获得最准确的数据。' : 'ipipbright currently provides you with the following 6 solutions:<br>Dynamic Residential, Static Residential, Dedicated Data Center, Dynamic Long-term ISP, Dynamic Data Center, Mobile Proxy.<br>In addition, we also provide a "Web Unlock Tool" to achieve a web crawler rate of more than 99.99%, one-click send request, you can easily get the most accurate data.',
        faq11q: lang === 'zh' ? 'ipipbright代理可运用于哪些业务场景？' : 'Which business scenarios can ipipbright proxy be used for?',
        faq11a: lang === 'zh' ? 'ipipbright代理可运用于以下业务场景：<br>品牌保护、广告验证、网站测试、股市数据、市场调查、竞争对手情报、抓取索引、邮件保护、<br>SEO监控优化、旅游信息聚合等，您的业务具体适用哪种代理，您可咨询 客户经理 为您解答。' : 'ipipbright proxy can be used in the following business scenarios:<br>Brand protection, ad verification, website testing, stock market data, market research, competitor intelligence, crawling indexes, email protection,<br>SEO monitoring optimization, travel information aggregation, etc. Which proxy is suitable for your specific business, you can consult the account manager for answers.',
        // Footer translations
        contactInfo: lang === 'zh' ? '联系我们' : 'Contact Info',
        usefulLinks: lang === 'zh' ? '有用链接' : 'Useful Links',
        support: lang === 'zh' ? '支持' : 'Support',
        privacyPolicy: lang === 'zh' ? '隐私政策' : 'Privacy Policy',
        servicePolicy: lang === 'zh' ? '服务政策' : 'Service Policy',
        welcomeText: lang === 'zh' ? '欢迎尝试我们的产品！' : 'Welcome to try our products!',
        // Footer translations
        footerDesc: lang === 'zh' ? '提供全球动态IP代理服务，覆盖200+国家和地区，拥有超过1亿+IP资源，稳定可靠，满足各类业务需求。' : 'Provide global dynamic IP proxy services, covering 200+ countries and regions, with over 100 million+ IP resources, stable and reliable, meeting various business needs.',
        followUs: lang === 'zh' ? '关注我们' : 'Follow Us',
        quickLinks: lang === 'zh' ? '快速链接' : 'Quick Links',
        productServices: lang === 'zh' ? '产品服务' : 'Product Services',
        contactUs: lang === 'zh' ? '联系我们' : 'Contact Us',
        supportText: lang === 'zh' ? '24/7技术支持，随时为您解答问题，提供专业的IP代理解决方案。' : '24/7 technical support, ready to answer your questions and provide professional IP proxy solutions.',
        copyright: lang === 'zh' ? 'ipipbright. © 2023 保留所有权利。' : 'ipipbright. © 2023 All Rights Reserved.',
        // FAQ Data - Pricing (second tab)
        faq12q: lang === 'zh' ? '如何免费测试？' : 'How to test for free?',
        faq12a: lang === 'zh' ? '新用户注册后进行实名认证，添加白名单按照使用流程即可免费测试动态流量，个人认证送30元额度，免费试用230M流量，技术认证送80元额度，免费试用600M流量，企业认证送150元额度，免费试用1G流量' : 'After new users register, they can verify their identity, add a whitelist, and follow the usage process to test dynamic traffic for free. Personal authentication gives 30 yuan credit, free trial of 230M traffic; technical authentication gives 80 yuan credit, free trial of 600M traffic; enterprise authentication gives 150 yuan credit, free trial of 1G traffic.',
        faq13q: lang === 'zh' ? 'IP是怎么收费的？' : 'How are IPs charged?',
        faq13a: lang === 'zh' ? '动态IP按照流量进行收费，流量计算方式为：上行+下行，计算上传的流量加下载的流量总和；数据中心IP、静态住宅按照IP个数计费' : 'Dynamic IP is charged according to traffic, calculated as: upload + download, the sum of uploaded and downloaded traffic; data center IP and static residential are charged according to the number of IPs.',
        faq14q: lang === 'zh' ? '生成的API链接没有账号标识，如何计费' : 'The generated API link has no account identifier, how to charge?',
        faq14a: lang === 'zh' ? '通过白名单判定，只有服务器ip在白名单列表里才能获取和使用ip，否则是提取不了ip的，一个白名单IP只能在一个账号里使用，按照白名单所在账号扣除流量费用' : 'Determined by whitelist, only server IP in the whitelist can obtain and use IP, otherwise IP cannot be extracted. One whitelist IP can only be used in one account, and traffic fees are deducted according to the account where the whitelist is located.',
        faq15q: lang === 'zh' ? '支持开具发票吗？' : 'Do you support invoice issuance?',
        faq15a: lang === 'zh' ? '联系客服可以开具电子发票，纸质发票（专票）需要签订购买合同，电子发票没有金额限制，开票顺序是从大金额到小金额，金额小的开具有时效性，可能出现次月开具的情况' : 'Contact customer service to issue electronic invoices. Paper invoices (special invoices) require a purchase contract. There is no amount limit for electronic invoices. The invoice issuance order is from large to small amounts. Small amounts have a time limit and may be issued in the next month.',
        faq16q: lang === 'zh' ? '免费赠送流量用完后，会自动扣费吗？' : 'Will it automatically deduct fees after the free traffic is used up?',
        faq16a: lang === 'zh' ? '不会自动扣费，免费赠送的流量用完后，将无法继续获取代理，只有在购买套餐或充值后，按照价格计费使用。' : 'It will not automatically deduct fees. After the free traffic is used up, you will not be able to continue to obtain proxies. You can only use it according to the price after purchasing a package or recharging.',
        faq17q: lang === 'zh' ? '额度套餐有时效吗？额度会清空吗？' : 'Does the credit package have a time limit? Will the credit be cleared?',
        faq17a: lang === 'zh' ? '额度套餐是通过账户充值获得专属额度，账户额度没有时效限制<br>30天时效是首次充值时，首次使用代理的计费单价时效，30天内按照套餐优惠单价扣费 超过30天，按照原价计费：<br>动态住宅：130￥/GB<br>动态数据中心：20￥/GB<br>动态长效ISP：130￥/GB' : 'The credit package is obtained through account recharge. There is no time limit for account credit.<br>The 30-day validity period is the validity period of the billing unit price for the first use of the proxy when recharging for the first time. Within 30 days, it is deducted according to the package preferential unit price. After 30 days, it is charged according to the original price:<br>Dynamic Residential: 130￥/GB<br>Dynamic Data Center: 20￥/GB<br>Dynamic Long-term ISP: 130￥/GB',
        // FAQ Data - Pricing (second tab continued)
        faq18q: lang === 'zh' ? '额度套餐充值后可以使用哪些套餐类型？' : 'Which package types can be used after recharging the credit package?',
        faq18a: lang === 'zh' ? '账户额度有两种使用方式：<br>1、动态住宅/动态数据中心/动态长效ISP/超级代理，根据代理使用量扣费。<br>2、静态住宅/独享数据中心，支持使用账户额度购买对应套餐。' : 'There are two ways to use account credit:<br>1. Dynamic Residential/Dynamic Data Center/Dynamic Long-term ISP/Super Proxy, charged according to proxy usage.<br>2. Static Residential/Dedicated Data Center, support using account credit to purchase corresponding packages.',
        faq19q: lang === 'zh' ? '如果IP过期了，续费后可以继续使用同一个IP吗？' : 'If the IP expires, can I continue to use the same IP after renewing?',
        faq19a: lang === 'zh' ? 'IP过期后无法续费，请注意过期时间并在IP到期前续费' : 'IP cannot be renewed after expiration. Please pay attention to the expiration time and renew before the IP expires.',
        faq20q: lang === 'zh' ? '静态住宅IP有流量限制吗？' : 'Is there a traffic limit for static residential IP?',
        faq20a: lang === 'zh' ? '按照数量计费，没有流量限制' : 'Charged by quantity, no traffic limit.',
        faq21q: lang === 'zh' ? '独享数据中心和动态数据中心有什么区别？' : 'What is the difference between dedicated data center and dynamic data center?',
        faq21a: lang === 'zh' ? '两种IP都来自IDC机房，标记为机房IP<br>动态数据中心按照流量计费，自定义1-30min IP时效，高效轮转<br>独享数据中心按照IP数量计费，是个人专享使用的长效IP地址，可选择周/月/季或定制IP时效' : 'Both IPs come from IDC computer rooms and are marked as computer room IPs.<br>Dynamic data center is charged according to traffic, with custom 1-30min IP validity period, efficient rotation.<br>Dedicated data center is charged according to the number of IPs, which is a long-term IP address exclusively for personal use, with optional weekly/monthly/quarterly or customized IP validity period.',
        faq22q: lang === 'zh' ? '额度套餐与产品套餐有什么区别？' : 'What is the difference between credit package and product package?',
        faq22a: lang === 'zh' ? '产品套餐：根据业务需要选择动态住宅、静态住宅、数据中心、动态ISP或移动代理，套餐时效<br>包括周套餐、月套餐、季度套餐或定制时效，套餐到期将清空流量。<br>额度套餐：根据需要选择充值额度，充值的额度可以使用ipipbright所有代理类型。<br>动态住宅/动态数据中心/动态长效ISP/超级代理，根据代理使用量扣费，随用随扣；<br>静态住宅/独享数据中心，支持使用账户额度购买对应套餐。' : 'Product package: Choose dynamic residential, static residential, data center, dynamic ISP or mobile proxy according to business needs, package validity period<br>including weekly package, monthly package, quarterly package or customized validity period, the package will clear traffic when it expires.<br>Credit package: Choose recharge amount according to needs, the recharged amount can use all ipipbright proxy types.<br>Dynamic Residential/Dynamic Data Center/Dynamic Long-term ISP/Super Proxy, charged according to proxy usage, deducted as you use;<br>Static Residential/Dedicated Data Center, support using account credit to purchase corresponding packages.',
        faq23q: lang === 'zh' ? '未使用完的流量能否转存到下个月？' : 'Can unused traffic be carried over to next month?',
        faq23a: lang === 'zh' ? '若您购买了 动态住宅包月套餐，流量未在1个月内使用完，则不可转存到下个月，<br>您可在购买前考虑好用量，选择适合您的月度套餐；若您购买了 额度套餐，<br>则按照使用量扣费，流量使用无时效问题，随用随扣。' : 'If you purchase a monthly dynamic residential package and the traffic is not used up within 1 month, it cannot be carried over to the next month.<br>You can consider your usage before purchasing and choose a monthly package suitable for you; if you purchase a credit package,<br>it is charged according to usage, and there is no time limit for traffic usage, deducted as you use.',
        faq24q: lang === 'zh' ? 'ipipbright是否支持城市级定位？' : 'Does ipipbright support city-level positioning?',
        faq24a: lang === 'zh' ? 'ipipbright支持多个国家的城市精准定位，您可从指定的国家城市访问目标网站，详情可咨询 客户经理。' : 'ipipbright supports precise city positioning in multiple countries. You can access target websites from designated countries and cities. For details, please consult the account manager.',
        // FAQ Data - Account (third tab)
        faq25q: lang === 'zh' ? 'IP限制使用终端设备数量吗' : 'Does IP limit the number of terminal devices used?',
        faq25a: lang === 'zh' ? '动态按照流量计费，对并发和同时连接数没有限制。' : 'Dynamic is charged according to traffic, with no restrictions on concurrency and simultaneous connections.',
        faq26q: lang === 'zh' ? '账密认证如何使用？' : 'How to use account password authentication?',
        faq26a: lang === 'zh' ? '账密认证是通过主账户创建认证账户进行流量分配。用户可以通过创建多个“认证账户”，给每个认证账户设置流量额度，根据业务需求灵活使用。具体操作参照“账密认证使用教程”。' : 'Account password authentication allocates traffic by creating authentication accounts through the main account. Users can create multiple "authentication accounts", set traffic quotas for each, and use them flexibly according to business needs. For specific operations, refer to the "Account Password Authentication Usage Tutorial".',
        faq27q: lang === 'zh' ? '服务器IP被多个账号加入白名单会怎样？' : 'What happens if a server IP is added to the whitelist by multiple accounts?',
        faq27a: lang === 'zh' ? '例如A、B两个帐号同时使用一个服务器，服务器IP保存在A账户，则扣除A账户流量，如在B账户，则扣除B账户流量；如服务器IP已保存在A账户，B账户再次添加，则会顶到A账户服务器IP留存，使用流量则扣除B账户' : 'For example, if accounts A and B use the same server, and the server IP is saved in account A, traffic will be deducted from account A; if in account B, traffic will be deducted from account B. If the server IP has been saved in account A, and account B adds it again, it will replace the server IP retention in account A, and traffic will be deducted from account B when used.',
        faq28q: lang === 'zh' ? '链接生成的IP可以一直使用吗？' : 'Can the IP generated by the link be used permanently?',
        faq28a: lang === 'zh' ? 'api代理模式，会不定时升级维护服务器，IP和端口也会改变，不建议长时间一直用一个IP段，可以每几天获取换一次。如果是账密代理模式可以一直用。' : 'In API proxy mode, servers are upgraded and maintained from time to time, and IPs and ports will also change. It is not recommended to use one IP segment for a long time. You can obtain and change it every few days. If it is account password proxy mode, it can be used permanently.',
        // FAQ Data - Troubleshooting (fourth tab)
        faq29q: lang === 'zh' ? '账户有流量，生成API链接提示额度不足' : 'Account has traffic, but generating API link prompts insufficient credit',
        faq29a: lang === 'zh' ? '请在ipipbright账户后台检查是否添加白名单，添加白名单后再次获取API链接，若已添加，删掉白名单重新添加，再次获取API链接' : 'Please check if you have added a whitelist in the ipipbright account backend. After adding the whitelist, obtain the API link again. If it has been added, delete the whitelist and re-add it, then obtain the API link again.',
        faq30q: lang === 'zh' ? '如何通过程序判断代理是否失效' : 'How to judge if a proxy is invalid through a program?',
        faq30a: lang === 'zh' ? '官网后台可以设置IP时效，动态最长可以设置30分钟，IP是隧道转发的，失效后会自动切换' : 'You can set IP validity period in the official website backend. The maximum dynamic validity period can be set to 30 minutes. IP is tunnel forwarded and will automatically switch after invalidation.'
      };
    },
    tabs() {
      return [
        { value: 'first', label: this.t.tabGettingStarted },
        { value: 'second', label: this.t.tabPricing },
        { value: 'third', label: this.t.tabAccount },
        { value: 'fourth', label: this.t.tabTroubleshooting }
      ];
    },
    faqData() {
      return {
        first: [
          {
            question: this.t.faq1q,
            answer: this.t.faq1a
          },
          {
            question: this.t.faq2q,
            answer: this.t.faq2a
          },
          {
            question: this.t.faq3q,
            answer: this.t.faq3a
          },
          {
            question: this.t.faq4q,
            answer: this.t.faq4a
          },
          {
            question: this.t.faq5q,
            answer: this.t.faq5a
          },
          {
            question: this.t.faq6q,
            answer: this.t.faq6a
          },
          {
            question: this.t.faq7q,
            answer: this.t.faq7a
          },
          {
            question: this.t.faq8q,
            answer: this.t.faq8a
          },
          {
            question: this.t.faq9q,
            answer: this.t.faq9a
          },
          {
            question: this.t.faq10q,
            answer: this.t.faq10a
          },
          {
            question: this.t.faq11q,
            answer: this.t.faq11a
          }
        ],
        second: [
          {
            question: this.t.faq12q,
            answer: this.t.faq12a
          },
          {
            question: this.t.faq13q,
            answer: this.t.faq13a
          },
          {
            question: this.t.faq14q,
            answer: this.t.faq14a
          },
          {
            question: this.t.faq15q,
            answer: this.t.faq15a
          },
          {
            question: this.t.faq16q,
            answer: this.t.faq16a
          },
          {
            question: this.t.faq17q,
            answer: this.t.faq17a
          },
          {
            question: this.t.faq18q,
            answer: this.t.faq18a
          },
          {
            question: this.t.faq19q,
            answer: this.t.faq19a
          },
          {
            question: this.t.faq20q,
            answer: this.t.faq20a
          },
          {
            question: this.t.faq21q,
            answer: this.t.faq21a
          },
          {
            question: this.t.faq22q,
            answer: this.t.faq22a
          },
          {
            question: this.t.faq23q,
            answer: this.t.faq23a
          },
          {
            question: this.t.faq24q,
            answer: this.t.faq24a
          }
        ],
        third: [
          {
            question: this.t.faq25q,
            answer: this.t.faq25a
          },
          {
            question: this.t.faq26q,
            answer: this.t.faq26a
          },
          {
            question: this.t.faq27q,
            answer: this.t.faq27a
          },
          {
            question: this.t.faq28q,
            answer: this.t.faq28a
          }
        ],
        fourth: [
          {
            question: this.t.faq29q,
            answer: this.t.faq29a
          },
          {
            question: this.t.faq30q,
            answer: this.t.faq30a
          }
        ]
      };
    }
  },
  methods: {
    // 设置语言
    setLanguage(lang) {
      this.changeLanguage(lang);
      this.activeDropdown = '';
    },
    // 切换移动端菜单
    toggleMobileMenu() {
      this.isMobileMenuOpen = !this.isMobileMenuOpen;
    },
    // 处理移动端导航链接点击
    handleMobileNavClick(targetRoute) {
      // 检查是否为当前路由，避免重复导航错误
      if (this.$route.path !== targetRoute) {
        this.$router.push(targetRoute);
      }
      // 无论是否导航，都关闭菜单
      this.isMobileMenuOpen = false;
      this.activeDropdown = '';
    },
    // 切换下拉菜单
    toggleDropdown(event, dropdownName) {
      event.preventDefault();
      if (this.activeDropdown === dropdownName) {
        this.activeDropdown = '';
      } else {
        this.activeDropdown = dropdownName;
      }
    },
    // 滚动到指定部分
    scrollToSection(sectionId) {
      const element = document.getElementById(sectionId);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    },
    // 滚动到顶部
    scrollToTop() {
      console.log('scrollToTop called');
      
      // 方法1：使用window.location.href直接跳转到页面顶部
      try {
        window.location.href = '#';
      } catch (e) {
        console.error('Method 1 failed:', e);
      }
      
      // 方法2：使用document.documentElement.scrollIntoView
      try {
        document.documentElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
      } catch (e) {
        console.error('Method 2 failed:', e);
      }
      
      // 方法3：使用document.body.scrollIntoView
      try {
        document.body.scrollIntoView({ behavior: 'smooth', block: 'start' });
      } catch (e) {
        console.error('Method 3 failed:', e);
      }
      
      // 方法4：直接设置scrollTop为0
      try {
        document.documentElement.scrollTop = 0;
        document.body.scrollTop = 0;
      } catch (e) {
        console.error('Method 4 failed:', e);
      }
      
      // 方法5：查找所有可能的滚动容器并设置scrollTop为0
      try {
        const scrollableElements = document.querySelectorAll('div, section, main, body, html');
        scrollableElements.forEach(el => {
          if (el.scrollTop > 0) {
            el.scrollTop = 0;
          }
        });
      } catch (e) {
        console.error('Method 5 failed:', e);
      }
    },
    toggleAccordion(tab, index) {
      if (this.activeAccordion[tab] === index) {
        this.activeAccordion[tab] = null;
      } else {
        this.activeAccordion[tab] = index;
      }
    }
  },
  mounted() {
    // 使用requestAnimationFrame定期检查滚动位置
    const checkScrollPosition = () => {
      // 同时检查window.scrollY和document.documentElement.scrollTop，确保在不同浏览器中都能获取到正确的滚动位置
      const scrollY = window.scrollY || document.documentElement.scrollTop || document.body.scrollTop
      const goTopBtn = document.getElementById('simple-go-top')
      if (goTopBtn) {
        if (scrollY > 300) {
          goTopBtn.style.opacity = '1'
          goTopBtn.style.visibility = 'visible'
        } else {
          goTopBtn.style.opacity = '0'
          goTopBtn.style.visibility = 'hidden'
        }
      }
      // 更新isSticky状态
      this.isSticky = scrollY > 50
      
      // 继续下一帧检查
      this.animationFrameId = requestAnimationFrame(checkScrollPosition)
    }
    
    // 启动requestAnimationFrame循环
    this.animationFrameId = requestAnimationFrame(checkScrollPosition)
  },
  beforeDestroy() {
    // 取消requestAnimationFrame循环
    if (this.animationFrameId) {
      cancelAnimationFrame(this.animationFrameId)
    }
  }
}
</script>

<style scoped>
/* CSS Variables */
:root {
  --fontFamily: 'Nunito', sans-serif;
  --mainColor: #1581c6;
  --optionalColor: #6F8BA4;
  --whiteColor: #ffffff;
  --blackColor: #3B566E;
  --fontSize: 16px;
  --transition: .5s;
}

/* Default Button Styles */
.default-btn {
  display: inline-block;
  border: none;
  box-shadow: 0;
  transition: var(--transition);
  text-decoration: none;
  background-color: #ffffff;
  color: #1581c6;
  padding: 12px 35px;
  position: relative;
  z-index: 1;
  border-radius: 5px;
  font-size: 15px;
  font-weight: 700;
}

.default-btn:hover {
  color: #ffffff;
  border-color: transparent;
  border: 0;
}

.default-btn:hover::before {
  opacity: 1;
  visibility: visible;
  width: 100%;
}

.default-btn::before {
  content: '';
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  z-index: -1;
  opacity: 0;
  visibility: hidden;
  border-radius: 5px;
  transition: var(--transition);
  background: #1581c6;
  width: 0%;
  height: 100%;
}

/* Container Styles */
.container {
  width: 100%;
  padding-right: 15px;
  padding-left: 15px;
  margin-right: auto;
  margin-left: auto;
}

@media (min-width: 576px) {
  .container {
    max-width: 540px;
  }
}

@media (min-width: 768px) {
  .container {
    max-width: 720px;
  }
}

@media (min-width: 992px) {
  .container {
    max-width: 960px;
  }
}

@media (min-width: 1200px) {
  .container {
    max-width: 1140px;
  }
}

/* Padding Styles */
.ptb-100 {
  padding-top: 100px;
  padding-bottom: 100px;
}

.pt-100 {
  padding-top: 100px;
}

.pb-100 {
  padding-bottom: 100px;
}

/* Background Styles */
.bg-light {
  background-color: #2d2c28 !important;
}

/* Desktop menu sticky styles */
#sticky-header {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 9999;
  background: #32312d;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  width: auto;
}

/* Mobile menu container */
.mobile-menu-container {
  position: relative;
  z-index: 99999;
}

/* Mobile menu header sticky styles */
.mobile-menu-header {
  position: fixed !important;
  top: 0;
  left: 0;
  right: 0;
  width: 100%;
  z-index: 99999;
  background: #32312d;
  min-height: 60px;
  padding: 4px 0 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

/* Mobile menu body should be fixed to viewport */
.mobile-menu-body {
  position: fixed !important;
  top: 60px;
  left: 0;
  right: 0;
  /* Make menu height smaller than full viewport */
  max-height: 70vh;
  margin-top: 0;
  z-index: 99998;
  overflow-y: auto;
  background: rgba(255, 255, 255, 0.95) !important;
  backdrop-filter: blur(10px);
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
  border-bottom-left-radius: 20px;
  border-bottom-right-radius: 20px;
}

/* Make menu list background transparent */
.mobile-menu-list {
  background: transparent !important;
}

/* Make menu items background transparent */
.mobile-menu-item {
  background: transparent !important;
}

/* Adjust menu link styles */
.mobile-menu-link {
  color: #fff !important;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.5);
}

.mobile-menu-link:hover {
  color: #ccc !important;
}

.mobile-menu-expand {
  color: #fff !important;
}

.mobile-sub-menu {
  background: rgba(0, 0, 0, 0.7) !important;
}

.mobile-sub-menu-link {
  color: #fff !important;
}

.mobile-sub-menu-link:hover {
  color: #ccc !important;
}

.mobile-auth-btn {
  color: #fff !important;
  background: rgba(255, 255, 255, 0.2) !important;
  border: 1px solid rgba(255, 255, 255, 0.3) !important;
}

.mobile-auth-btn:hover {
  background: rgba(255, 255, 255, 0.3) !important;
  color: #fff !important;
}

/* Mobile menu toggle button */
.mobile-menu-toggle {
  width: 40px;
  height: 40px;
  padding: 10px;
  cursor: pointer;
  color: #fff;
  text-decoration: none;
  font-size: 16px;
  line-height: 20px;
  font-weight: 700;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-left: auto;
  margin-right: 15px;
  border-radius: 4px;
}

.mobile-menu-toggle span {
  display: block;
  background: #fff;
  height: 3px;
  width: 24px;
  margin: 2px 0;
  transition: all 0.3s ease;
}

/* FAQ Banner Section */
.faq-banner-section {
  margin-top: 80px;
}

/* Remove margin-top on mobile */
@media (max-width: 768px) {
  .faq-banner-section {
    margin-top: 0;
  }
}

/* Mobile Menu Button Styles */
@media (max-width: 991px) {
  .template-responsive-navbar .others-option {
    display: flex !important;
    flex-direction: column;
    gap: 10px;
    margin-top: 20px;
    position: static;
  }
  .template-responsive-navbar .others-option .item {
    margin-left: 0;
    width: 100%;
  }
  .template-responsive-navbar .others-option .item:first-child {
    margin-left: 0;
  }
  .template-responsive-navbar .others-option .default-btn {
    width: 100%;
    text-align: center;
    padding: 14px 35px;
    font-size: 16px;
    border-radius: 8px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  }
  .template-responsive-navbar .others-option .item:nth-child(1) .default-btn {
    background-color: var(--whiteColor);
    color: var(--mainColor);
    border: 2px solid var(--mainColor);
  }
  .template-responsive-navbar .others-option .item:nth-child(1) .default-btn::before {
    background: linear-gradient(135deg, var(--mainColor) 0%, var(--secondaryColor) 100%);
  }
  .template-responsive-navbar .others-option .item:nth-child(2) .default-btn {
    background-color: var(--mainColor);
    color: var(--whiteColor);
  }
  .template-responsive-navbar .others-option .item:nth-child(2) .default-btn::before {
    background: linear-gradient(135deg, var(--secondaryColor) 0%, var(--mainColor) 100%);
  }
}
</style>

<style scoped>
.faq-banner-section {
  background-color: #2d2c28 !important;
  text-align: center;
  margin-top: 100px;
  color: #ffffff;
}

.faq-banner-section h1 {
  font-size: 2.5rem;
  font-weight: 700;
  margin-bottom: 20px;
  color: #ffffff;
  position: relative;
  display: inline-block;
  line-height: 1.3;
}

/* 首字母样式和下划线 */
.faq-banner-section h1::before {
  content: attr(data-first-letter);
  position: relative;
  display: inline-block;
  margin-right: 3px;
}

/* 使用::after在首字母下方创建下划线 */
.faq-banner-section h1::after {
  content: '';
  position: absolute;
  left: 50%;
  bottom: 0;
  width: 30px;
  height: 4px;
  background: linear-gradient(135deg, #4146E6 0%, #6a30d1 100%);
  border-radius: 2px;
  transform: translateX(-50%);
}

/* FAQ Section Styles */
.faq-section {
  background-color: #2d2c28 !important;
  padding-top: 100px;
  padding-bottom: 100px;
}

.faq-content {
  max-width: 800px;
  margin: 0 auto;
}

.faq-tabs {
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 15px rgba(0, 0, 0, 0.08);
  overflow: hidden;
}

.tabs-container {
  width: 100%;
}

.tab-buttons {
  display: flex;
  border-bottom: 1px solid #eaeaea;
  background: #f8f9fa;
}

.tab-btn {
  flex: 1;
  padding: 15px 20px;
  border: none;
  background: transparent;
  cursor: pointer;
  font-size: 16px;
  font-weight: 500;
  color: #666;
  transition: all 0.3s ease;
  border-bottom: 3px solid transparent;
}

.tab-btn:hover {
  color: #4146E6;
}

.tab-btn.active {
  color: #4146E6;
  border-bottom-color: #4146E6;
  background: white;
}

.tab-content {
  padding: 30px;
  background: white;
}

.tab-panel {
  animation: fadeIn 0.3s ease;
}

@keyframes fadeIn {
  from { opacity: 0; transform: translateY(10px); }
  to { opacity: 1; transform: translateY(0); }
}

/* FAQ Accordion Styles */
.faq-accordion {
  border-radius: 8px;
  overflow: hidden;
}

.accordion-item {
  border-bottom: 1px solid #eaeaea;
  transition: all 0.3s ease;
}

.accordion-item:last-child {
  border-bottom: none;
}

.accordion-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 0;
  cursor: pointer;
  transition: all 0.3s ease;
}

.accordion-header:hover {
  color: #4146E6;
}

.accordion-header h3 {
  margin: 0;
  font-size: 18px;
  font-weight: 500;
  color: #333;
  transition: color 0.3s ease;
}

.accordion-icon {
  font-size: 20px;
  font-weight: bold;
  color: #999;
  transition: all 0.3s ease;
}

.accordion-item.active .accordion-icon {
  transform: rotate(45deg);
  color: #4146E6;
}

.accordion-body {
  padding: 0 0 20px;
  overflow: hidden;
  transition: all 0.3s ease;
}

.accordion-body p {
  margin: 0;
  color: #666;
  line-height: 1.6;
  font-size: 16px;
}

/* Mobile menu styles */
.mobile-menu-area {
  background: #fff;
}

.mobile-menu-container {
  position: relative;
}

.mobile-menu-header {
  background: #32312d;
  min-height: 60px;
  padding: 4px 0 0;
  position: relative;
  width: 100%;
  z-index: 999999;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.mobile-menu-logo {
  flex: 1;
}

.mobile-menu-toggle {
  width: 40px;
  height: 40px;
  padding: 10px;
  cursor: pointer;
  color: #fff;
  text-decoration: none;
  font-size: 16px;
  line-height: 20px;
  font-weight: 700;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-left: auto;
  margin-right: 15px;
  /* background: rgba(255, 255, 255, 0.1); */
  border-radius: 4px;
}

.mobile-menu-toggle span {
  display: block;
  background: #fff;
  height: 3px;
  width: 24px;
  margin: 2px 0;
  transition: all 0.3s ease;
}

.mobile-menu-body {
  background: #fff;
  border: 1px solid #eaeaea;
  border-top: none;
}

.mobile-menu-list {
  padding: 0;
  margin: 0;
  list-style-type: none;
  background: #fff;
}

.mobile-menu-item {
  border-top: 1px solid #ddd;
}

.mobile-menu-item:first-child {
  border-top: none;
}

.mobile-menu-link-wrapper {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.mobile-menu-link {
  display: block;
  padding: 1em 5%;
  color: #444;
  font-size: 14px;
  font-weight: bold;
  text-decoration: none;
  text-transform: uppercase;
  flex: 1;
}

.mobile-menu-link:hover {
  color: #1581c6;
}

.mobile-menu-expand {
  display: block;
  padding: 1em;
  color: #444;
  font-size: 14px;
  font-weight: bold;
  text-decoration: none;
  background: transparent;
  border: none;
  cursor: pointer;
}

.mobile-menu-expand:hover {
  color: #1581c6;
}

.mobile-sub-menu {
  padding: 0;
  margin: 0;
  list-style-type: none;
  background: #f8f8f8;
}

.mobile-sub-menu-item {
  border-top: 1px solid #eaeaea;
}

.mobile-sub-menu-link {
  display: block;
  padding: 0.8em 10%;
  color: #151948;
  font-size: 13px;
  font-weight: normal;
  text-decoration: none;
  text-transform: capitalize;
}

.mobile-sub-menu-link:hover {
  color: #1581c6;
}

/* Mobile Responsive */
@media (max-width: 768px) {
  .faq-banner-section {
    margin-top: 0 !important;
  }
}
</style>